export const state = {
  title: 'Multifirma',
  sideColapsed: false,
};
